export default function() {
    let tabbtn = document.querySelectorAll('[data-toggle]');
    let tabctnt = document.querySelectorAll('[data-target]');

    tabbtn.forEach((btn) => {
        btn.addEventListener('click', () => {
            const isActive = btn.classList.contains('tabs__title--active');

            tabbtn.forEach((btns) => {
                btns.classList.remove('tabs__title--active', 'tab__accordionbutton--active');
            });
            tabctnt.forEach((tab) => {
                tab.setAttribute('data-open', '');
            });

            if (!isActive) {
                btn.classList.add('tabs__title--active', 'tab__accordionbutton--active');

                let btnatrb = btn.getAttribute('data-src');
                tabctnt.forEach((tab) => {
                    let tabatrb = tab.getAttribute('data-target');
                    if (btnatrb === tabatrb) {
                        tab.setAttribute('data-open', 'true');
                    }
                });
            }
        });
    });
}
